const API = {
  // For Live Server
  BASE_LINK: "https://api.goodgoodpiggy.com/api/v2",
  // For Test Server
  // BASE_LINK: "https://devapi.goodgoodpiggy.in/api",
  // For Production Server
  // BASE_LINK: "http://192.168.1.11:4012/api",
};
export default API;
